export const interaction = ({
  type = "INTERACTION",
  action,
  page,
  element = null,
  value = null,
  resourceId = null,
}) => ({
  type,
  data: {
    action,
    page,
    element,
    value,
    resourceId,
  },
});
